// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SectionInfo_wrap__mnPaF","name":"SectionInfo_name__3t7cp","info":"SectionInfo_info__PNVIr"};